export default __webpack_public_path__ + "static/media/royce.de002a37.jpeg";